<template>
    <v-container class="pa-0" fluid v-if="!loading">
        <v-card class="pa-2">
            <v-card-title class="pt-0 pb-0 justify-center">Duplicate candidates - Hosts</v-card-title>
            <v-data-table 
                :items="host_items" 
                :items-per-page="10" 
                :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                :headers="headersHost"
                >
                <template v-slot:item="props">
                    <tr class="align-text-top">
                        <td @click="$router.open('/eign/onEign/' + props.item.eign_encrid)"><a>{{ props.item.eign_code }}</a></td>
                        <td>{{ props.item.eign_stat }}</td>
                        <td :class="props.item.match_naam">{{ props.item.eign_voornaam }} {{ props.item.eign_naam }}<br>{{ props.item.eign_bedrijfsnaam }}</td>
                        <td :class="props.item.match_email">{{ props.item.eign_email }}<br>{{ props.item.eign_email_extra }}</td>
                        <td :class="props.item.match_tel">{{ props.item.eign_tel1_vcs }}<br>{{ props.item.eign_tel2_vcs }} {{ props.item.eign_tel3_vcs }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <v-card class="pa-2 mt-4">
            <v-card-title class="pt-0 pb-0 justify-center">Duplicate candidates - leads</v-card-title>
            <v-data-table 
                :items="lead_items" 
                :items-per-page="10" 
                :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                :headers="headersLead"      
                >
                <template v-slot:item="props">
                    <tr class="align-text-top">
                        <td @click="$router.open('/pten/onPten/' + props.item.pten_encrid)"><a>{{ props.item.pten_code }}</a></td>
                        <td>{{ props.item.pten_stat }}</td>
                        <td :class="props.item.match_naam">{{ props.item.pten_voornaam }} {{ props.item.pten_naam }}</td>
                        <td :class="props.item.match_email">{{ props.item.pten_email }}</td>
                        <td :class="props.item.match_tel">{{ props.item.pten_tel1_vcs }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
    <v-container class="pa-5 px-1" fluid v-else>
        <cardWait/>
    </v-container>
</template>

<script>
    import cardWait from "@/components/pten/cardWait.vue";

    export default {
        props: {
            pten_encrid: {
                type: String,
                required: true,
            },
            pten: {
                required: false,
            },
        },
        components: {
            cardWait,
        },
        data() {
            return {
                loading: true,
                host_items: [],
                lead_items: [],
                headersHost: [
                    {text: 'Id', value: 'eign_code'},
                    {text: 'Status', value: 'eign_stat', sortable: false, width: "80px" },
                    {text: 'Name', value: 'eign_naam'},
                    {text: 'E-mail', value: 'eign_mail'},
                    {text: 'Tel number', value: 'eign_tel1_vcs'},
                ],      
                headersLead: [
                    {text: 'Id', value: 'pten_code'},
                    {text: 'Status', value: 'pten_stat', sortable: false, width: "160px" },
                    {text: 'Name', value: 'pten_naam'},
                    {text: 'E-mail', value: 'pten_email'},
                    {text: 'Tel number', value: 'pten_tel1_vcs'},
                ],      
            }
        },
        mounted() {
            this.getPtenDuplicates();
        },
        methods: {
            getPtenDuplicates() {
                this.loading = true;
                this.host_items = [],
                this.lead_items =[],
                this.$axios.post("ares/json/ares/pten/getPtenDuplicates.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPtenDuplicates"
                    },
                    getPtenDuplicates: {
                        pten_encrid: this.pten_encrid,
                        pten: this.pten,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.host_items = res.data.getPtenDuplicates.host_items;
                        this.lead_items = res.data.getPtenDuplicates.lead_items;
                        this.loading = false;
                    }
                });
            },
            setPtenStatus(encrid, newStatus) {
                this.$axios.post("ares/json/ares/pten/setPtenStatus.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPtenStatus"
                    },
                    setPtenStatus: {
                        pten_encrid: encrid,
                        ptst_code: newStatus,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setPtenStatus.text,
                            color: res.data.setPtenStatus.color,
                        });
                        this.actionClick("refresh");
                    }
                });
            },
            actionClick(action) {
                this.$emit("actionClick", action);
            },
        }
    };
</script> 

<style scoped>
    .align-text-top {
        vertical-align: top;
    }
    .match {
        color: red;
        font-weight: bold;
    }
</style>
